import YesNoDialog from '../components/YesNoDialog/YesNoDialog';
import styles from '../SCSS/MyPeekavilleUnits.module.scss';

interface Props {
  all: boolean;
  actionLock: boolean;
  onHide: () => unknown;
  onConfirmLock: () => unknown;
  onConfirmUnlock: () => unknown;
  show: boolean;
}

const LockConfirmModal = (props: Props): JSX.Element => {
  const { all, actionLock, onHide, onConfirmLock, onConfirmUnlock, show } = props;

  const getModalTitle = () => {
    return all
      ? actionLock
        ? 'Are you sure you want to lock ALL units?'
        : 'Are you sure you want to unlock ALL units?'
      : actionLock
        ? 'Are you sure you want to lock this unit?'
        : 'Are you sure you want to unlock this unit?';
  };

  const handleOnHide = () => {
    onHide();
  };

  const handleOnConfirm = () => {
    if (actionLock) {
      onConfirmLock();
    } else {
      onConfirmUnlock();
    }
  };

  const handleOnCancel = () => {
    onHide();
  };

  return (
    <YesNoDialog
      isShow={show}
      onHide={handleOnCancel}
      title={getModalTitle()}
      continueButtonLabel='Continue'
      cancelButtonLabel='Cancel'
      onNoResponse={handleOnHide}
      onYesResponse={handleOnConfirm}
    >
      {actionLock ? (
        <p className={styles.modalBodyText}>
          Locking this unit <strong>disables</strong> students in this classroom from accessing it on{' '}
          <strong>myPeekaville</strong>.
        </p>
      ) : (
        <p className={styles.modalBodyText}>
          Unlocking this unit <strong>enables</strong> students in this classroom to access it on{' '}
          <strong>myPeekaville</strong>.
        </p>
      )}
    </YesNoDialog>
  );
};

export default LockConfirmModal;
